import { useDispatch } from "react-redux"

import { bindActionCreators } from "@reduxjs/toolkit"

import { actions } from "./productObjCacheSlice"

export function useProductObjCacheActions() {
  const dispatch = useDispatch()
  return bindActionCreators(actions, dispatch)
}
